import type React from "react"

export const ShareNodes: React.FC<React.SVGAttributes<SVGSVGElement>> = (
  props,
) => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <title>Share Nodes</title>
    <path
      d="M14 3C14 4.65625 12.6562 6 11 6C10.0938 6 9.28125 5.625 8.71875 4.96875L5.90625 6.375C5.96875 6.59375 5.96875 6.8125 5.96875 7C5.96875 7.21875 5.96875 7.4375 5.90625 7.65625L8.71875 9.03125C9.28125 8.40625 10.0938 8 11 8C12.6562 8 14 9.34375 14 11C14 12.6562 12.6562 14 11 14C9.3125 14 8 12.6562 8 11C8 10.8125 8 10.5938 8.0625 10.375L5.25 8.96875C4.6875 9.625 3.875 10 3 10C1.3125 10 0 8.65625 0 7C0 5.34375 1.3125 4 3 4C3.875 4 4.6875 4.40625 5.25 5.03125L8.0625 3.65625C8 3.4375 8 3.21875 8 3C8 1.34375 9.3125 0 11 0C12.6562 0 14 1.34375 14 3ZM2.96875 8.5C3.8125 8.5 4.46875 7.84375 4.46875 7C4.46875 6.1875 3.8125 5.5 2.96875 5.5C2.15625 5.5 1.46875 6.1875 1.46875 7C1.46875 7.84375 2.15625 8.5 2.96875 8.5ZM11 1.5C10.1562 1.5 9.5 2.1875 9.5 3C9.5 3.84375 10.1562 4.5 11 4.5C11.8125 4.5 12.5 3.84375 12.5 3C12.5 2.1875 11.8125 1.5 11 1.5ZM11 12.5C11.8125 12.5 12.5 11.8438 12.5 11C12.5 10.1875 11.8125 9.5 11 9.5C10.1562 9.5 9.5 10.1875 9.5 11C9.5 11.8438 10.1562 12.5 11 12.5Z"
      fill="#938F94"
    />
  </svg>
)
